import { nullSafeToString } from '../lib/util';

/**
 * A session for editing the personalized artwork on a templated job, started by
 * {@link Collaterate.Order.startTemplateEdit startTemplateEdit}.
 *
 * The editor itself belongs to a third-party template vendor and is not part of the SDK: put `url` in an
 * iframe sized to `width` and `height` and let the shopper work in it.
 *
 * How the edit gets committed depends on the vendor. When `postbackRequired` is false the vendor tells
 * Collaterate directly and there is nothing more to do but re-read the previews. When it is true nothing
 * is saved until the theme calls {@link Collaterate.Order.saveTemplateEdit saveTemplateEdit} with the
 * session code the vendor hands back - skip that and the shopper's edit is silently lost.
 *
 * @property {string} url - (Read only) The url to load in an iframe for the shopper to edit in.
 * @property {string} width - (Read only) The width the vendor wants that iframe to be, as a CSS length.
 * @property {string} height - (Read only) The height the vendor wants that iframe to be, as a CSS length.
 * @property {boolean} postbackRequired - (Read only) Whether the theme must call {@link Collaterate.Order.saveTemplateEdit saveTemplateEdit} once the shopper is done. See above.
 * @property {string} templateVendor - (Read only) Which template vendor is behind this session, for themes that need to special-case one.
 */

class TemplateEditSession {
    constructor (data = {}) {
        this.url = nullSafeToString(data.url);
        this.width = nullSafeToString(data.width);
        this.height = nullSafeToString(data.height);
        this.postbackRequired = Boolean(data.postbackRequired);
        this.templateVendor = nullSafeToString(data.templateVendor);

        Object.freeze(this);
    }
}

export default TemplateEditSession;
